import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {IconTabler} from '@components/common/icon-tabler/icon-tabler'

const TwContainer = tw.div`
  min-w-full
  flex
  flex-col
  gap-12
`

const TwHeader = tw.div`
  flex
  items-center
  justify-between
  gap-16
  h-16
  text-sm-semibold
`

const TwContent = tw.div`
  flex
  flex-col
  gap-16
  text-xs-regular
`

const TwAction = tw.div`
  inline
  text-action-default
  text-xs-regular
  cursor-pointer
`

const TwFunction = tw.div`
  stroke-current
  hover:text-action-default
  cursor-pointer
`

const TwFooter = tw.div`
  flex
`

export const PromoSettings = (props: {onClose: () => void}) => {
  return (
    <TwContainer>
      <TwHeader>
        <div>{Lang.msg.myTasks.columnsSettings}</div>
        <TwFunction>
          <IconTabler
            icon="IconCustomClose"
            viewBox="0 0 24 24"
            customSize={16}
            className="flex-none block"
            onClick={props.onClose}
          />
        </TwFunction>
      </TwHeader>
      <TwContent>
        <div>{Lang.msg.myTasks.columnsSettingsPromoMessage}</div>
      </TwContent>
      <TwFooter>
        <div>
          <TwAction onClick={props.onClose}>
            {Lang.msg.myTasks.understood}
          </TwAction>
        </div>
      </TwFooter>
    </TwContainer>
  )
}
